import { ReloadOutlined } from "@ant-design/icons";
import { Button, Space, Tooltip, message } from "antd";
import { useState } from "react";
import axios from "../../../context/axiosConfig";
import { useAuth } from "../../../context/AuthContext";
import { usePaginationPrzelewy } from "../../../context/PaginationContextPrzelewy";

const DownloadXML = ({
	fileName,
	generatedFileId,
	generatedGroupId,
	isGroup = false,
}) => {
	const user = useAuth();
	const { pagination, setPagination } = usePaginationPrzelewy();
	const [isRegenerating, setIsRegenerating] = useState(false);

	const downloadXML = async (targetFileName = fileName) => {
		try {
			const response = await axios.post(
				"/przelewy/download/xml",
				{
					filename: targetFileName,
				},
				{
					responseType: "blob", // Important to handle file as binary
				},
			);

			// Create a Blob from the response
			const blob = new Blob([response.data], { type: "application/xml" });
			const link = document.createElement("a");

			// Create a link to the file
			link.href = window.URL.createObjectURL(blob);
			link.download = targetFileName;
			link.click();
		} catch (error) {
			console.error("Błąd pobierania pliku:", error);
		}
	};

	const regenerateXML = async () => {
		setIsRegenerating(true);
		try {
			const response = await axios.post("/przelewy/regenerate/xml", {
				generatedFileId,
				groupId: generatedGroupId,
				user: user?.user?.user?.mlg_users_id,
			});
			const regeneratedFileName =
				response?.data?.data?.fileName || fileName;
			await downloadXML(regeneratedFileName);
			message.success("XML został zregenerowany.");
			setPagination({ ...pagination, reload: !pagination.reload });
		} catch (error) {
			message.error(
				error?.response?.data?.message ||
					"Nie udało się zregenerować XML.",
			);
		} finally {
			setIsRegenerating(false);
		}
	};

	return (
		<Space size="small">
			<Button onClick={() => downloadXML()}>Pobierz XML</Button>
			<Tooltip title={isGroup ? "Regeneruj XML paczki" : "Regeneruj XML"}>
				<Button
					icon={<ReloadOutlined />}
					loading={isRegenerating}
					onClick={regenerateXML}
					disabled={!generatedFileId && !generatedGroupId}
				/>
			</Tooltip>
		</Space>
	);
};

export default DownloadXML;
